import React from 'react';
import HBErrorScreen, { HB_ERROR_SCREEN_TEST_ID } from './HBErrorScreen';
import HBText from '../HBText/HBText';
import { useHBTranslation } from '../HBUIProvider/HBUIProvider';
import type { HBWiresCrossedScreenProps } from './HBErrorScreen.types';

export const HB_WIRES_CROSSED_SCREEN_TEST_ID = 'hb-wires-crossed-screen';

const reloadPage = () => globalThis.location.reload();

/**
 * HoneyBook's standard "we've gotten our wires crossed" error page, shown when the
 * application has crashed and the user's only move is to reload. Copy is translated
 * from hbui's own locale bundles; every string can still be overridden per prop.
 */
const HBWiresCrossedScreen = ({
    message,
    onRefresh = reloadPage,
    refreshLabel,
    testId = HB_WIRES_CROSSED_SCREEN_TEST_ID,
    ticketId,
    title
}: HBWiresCrossedScreenProps) => {
    const t = useHBTranslation();

    return (
        <HBErrorScreen
            testId={testId}
            title={title ?? t('HBWiresCrossedScreen.title')}
            message={message ?? t('HBWiresCrossedScreen.message')}
            primaryAction={{
                label: refreshLabel ?? t('HBWiresCrossedScreen.refresh'),
                onClick: onRefresh
            }}
        >
            {ticketId && (
                <HBText
                    type="body16"
                    color="text.tertiary"
                    align="center"
                    testId={`${HB_ERROR_SCREEN_TEST_ID}--ticket-id`}
                >
                    {t('HBWiresCrossedScreen.ticketId', { ticketId })}
                </HBText>
            )}
        </HBErrorScreen>
    );
};

export default HBWiresCrossedScreen;
